import { type ContentTableItem } from "src/components/ContentTable/ContentTable";

export const mapStoresToContentTableItems = (
	stores: LocationStore[]
): ContentTableItem[] => {
	return stores.map((store) => ({
		id: store.id,
		name: store.name,
		isActive: true,
		lastUpdated: store.updatedAt,
		data: {
			region: store.region?.name ?? "—",
			area: store.area?.name ?? "—",
			lastsync: store.lastsync
		}
	}));
};
